import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Location } from '@angular/common'
import { fuseAnimations } from '../../../../../core/animations'
import { AdministrationService } from '../../../../services/administration.service'
import { ActivatedRoute } from '@angular/router'
import { AdministrationModel } from '../../../../models/administration.model'

@Component({
  selector: 'app-administration-details-sidenav',
  templateUrl: './administration-details-sidenav.component.html',
  styleUrls: ['./administration-details-sidenav.component.scss'],
  animations: fuseAnimations,
})
export class AdministrationDetailsSidenavComponent implements OnInit {
  @Input() view: string
  @Input() administration: AdministrationModel

  @Output()
  changeView = new EventEmitter<any>()

  baseUrl: string

  constructor(
    private administrationService: AdministrationService,
    private route: ActivatedRoute,
    private _location: Location,
  ) {
    this.view = this.route.snapshot.params['view']
  }

  ngOnInit() {
    this.baseUrl = 'administrations/' + this.administration.id
  }

  setLocation(event, field) {
    this.view = field

    if (field !== '') {
      this.changeView.emit(field)
      this._location.go(this.baseUrl + '/' + field)
    } else {
      this.changeView.emit(undefined)
      this._location.go(this.baseUrl)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration-details/administration-detail-sidenav/administration-details-sidenav.component.ts